import { getStoredAccessToken } from "../utils";

const host = window.location.protocol + "//" + window.location.host;

/**
 * Sends an authenticated HTTP request with application/json content.
 * @param  {url} url The web address.
 * @param  {string} [method = "GET"] The HTTP method.
 * @param  {object} [body = null] The data to send in the body as json.
 * @return Promise with the response.
 */
export async function authFetchAsync(url: string, method: string = "GET", body: any = null, signal?: AbortSignal): Promise<Response> {
    // // Commented code is for reference
    // const account = msalInstance.getActiveAccount();
    // if (!account) {
    //     throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
    // }

    // let response: AuthenticationResult | undefined = undefined;
    // try {
    //     response = await msalInstance.acquireTokenSilent({
    //         ...apiLoginRequest,
    //         account: account
    //     });
    // }
    // catch (err: any) {
    //     // Could also check if err instance of InteractionRequiredAuthError if you can import the class.
    //     if (err.name === "InteractionRequiredAuthError") {
    //         response = await msalInstance.acquireTokenPopup({
    //             ...apiLoginRequest,
    //             account: account
    //         });
    //     }
    //     console.error("authFetchAsync", err);
    // }
    // if (!response || !response.accessToken) return new Response(undefined, { status: 401 });

    return fetchWithTokenAsync(url, getStoredAccessToken(), method, body, signal);
}

/**
 * Sends an authenticated HTTP request with application/json content.
 * @param  {url} url The web address.
 * @param  {string} [accessToken = null] The access token.
 * @param  {string} [method = "GET"] The HTTP method.
 * @param  {object} [body = null] The data to send in the body as json.
 * @return Promise with the response.
 */
export async function fetchWithTokenAsync(url: string, accessToken: string, method: string = "GET", body: any = null, signal?: AbortSignal): Promise<Response> {

    if (url.startsWith("api")) {
        url = `${host}/${url}`;
    }

    return new Promise((resolve, reject) => {
        fetch(url, {
            method: method,
            signal,
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": `Bearer ${accessToken}`
            }),
            body: (body != null) ? JSON.stringify(body) : undefined
        })
        .then((response) => resolve(response))
        .catch(e => {
            if(e.name === "AbortError") {
                console.log("Aborted last API call...");
            }
        })
    });
}

export async function authFetchRawAsync(url: string, method: string = "GET", body: any = null): Promise<Response> {
    if (url.startsWith("api")) {
        url = `${host}/${url}`;
    }

    return new Promise((resolve, reject) => {
        fetch(url, {
            method: method,
            headers: new Headers({
                "Authorization": `Bearer ${getStoredAccessToken()}`
            }),
            body: (body != null) ? body : undefined
        }).then((response) => resolve(response));
        //.catch(error => reject(error));
    });
}


/**
 * Download a file with an authenticated HTTP request.
 * @param  {url} url The web address.
 * @param  {string} [method = "GET"] The HTTP method.
 * @return Promise.
 */
export async function authDownloadAsync(url: string, method: string = "GET", responseToDownload?: Response): Promise<Response> {
    let response;
    if( responseToDownload === undefined) {
        response = await authFetchRawAsync(url, method);
    } else {
        response = responseToDownload;
    }
     
    if (response.ok) {
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        const contentDisposition = response.headers.get("Content-Disposition");
        let fileName = "download";
        if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="?([^;"]+)[";]/);
            if (fileNameMatch!.length === 2) {
                fileName = fileNameMatch![1];
            }
        }
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", fileName);
        link.click();
        window.URL.revokeObjectURL(blobUrl);
    }
    return response;
}
